<template>
  <div class="py-4 container-fluid">
    <!-- <a class="btn btn-sm btn-primary" style="margin-right: 10px;" :href="apiUrl+'export-excel/inventory-transaction?pr_code='+search.pr_code+'&transaction_type='+search.transaction_type+'&po_number='+search.po_number+'&delivery_order_number='+search.delivery_order_number+'&supplier='+search.supplier['name']+'&project='+search.project['project_number']+'&user='+search.user['name']+'&item_name='+search.item_name['item_name']+'&reducted_select='+search.reducted_select+'&category_reduction='+search.category_reduction+'&pic_warehouse='+search.pic_warehouse['name']+'&warehouse_location='+search.warehouse_location['name']+'&date='+search.date+'&status='+search.status+''" target="_BLANK"><i class="fa fa-download fa-sm"></i> Export</a> -->
    <!-- ======= HERO ======= -->
    <div class="hero mb-4">
      <div class="hero-head">
        <div>
          <span class="hero-kicker"><i class="fas fa-clipboard-check"></i> Procurement · Purchase Request</span>
          <h3 class="hero-title">Purchase Request</h3>
          <span class="hero-sub">Pantau status PR dan progres tiap item, dari draf sampai barang diterima</span>
        </div>
        <div class="hero-actions">
          <button type="button" class="hero-btn hero-btn-main" @click="createWithSubForm()"><i class="fas fa-plus"></i> PR Baru</button>
        </div>
      </div>

      <div class="hero-body">
        <!-- donut tahapan item -->
        <div class="donut-wrap">
          <svg viewBox="0 0 120 120" class="donut">
            <circle cx="60" cy="60" r="48" class="donut-track" />
            <circle v-for="seg in donutSegments" :key="seg.key" cx="60" cy="60" r="48" class="donut-seg"
              :stroke="seg.color" :stroke-dasharray="seg.dash" :stroke-dashoffset="seg.offset" />
          </svg>
          <div class="donut-center">
            <span class="donut-num">{{ (prStats.stages.total || 0).toLocaleString('id-ID') }}</span>
            <span class="donut-lbl">Item PR</span>
          </div>
        </div>
        <div class="donut-legend">
          <div v-for="seg in donutSegments" :key="seg.key" class="legend-row no-click">
            <span class="legend-dot" :style="{ background: seg.color }"></span>
            <span class="legend-name">{{ seg.label }}</span>
            <span class="legend-val">{{ seg.value.toLocaleString('id-ID') }}</span>
          </div>
        </div>

        <!-- angka utama -->
        <div class="hero-metrics">
          <div class="metric">
            <span class="metric-lbl"><i class="fas fa-file-alt"></i> Total PR</span>
            <span class="metric-val">{{ (prStats.summary.total || 0).toLocaleString('id-ID') }} <small>· {{ prStats.summary.this_month || 0 }} bulan ini</small></span>
          </div>
          <div class="metric metric-click" @click="quickStatus('Draf')">
            <span class="metric-lbl"><i class="fas fa-user-check"></i> Menunggu Approval</span>
            <span class="metric-val" :class="{ 'text-warn-soft': prStats.summary.draft }">{{ prStats.summary.draft || 0 }} <small>PR draf</small></span>
            <span class="metric-note">Klik untuk melihat daftarnya</span>
          </div>
          <div class="metric metric-click" @click="quickDue('overdue')">
            <span class="metric-lbl"><i class="fas fa-exclamation-circle"></i> Lewat Date Required</span>
            <span class="metric-val" :class="{ 'text-danger-soft': prStats.summary.overdue }">{{ prStats.summary.overdue || 0 }} <small>PR</small></span>
            <span class="metric-note">Masih ada item yang belum diterima</span>
          </div>
        </div>

        <!-- WO dengan PR terbanyak -->
        <div class="podium">
          <span class="podium-title">WO dengan PR Terbanyak</span>
          <div v-for="(w, i) in prStats.topWo" :key="w.wo_code" class="podium-row" @click="quickSearch(w.wo_code)" :title="'Tampilkan PR untuk ' + w.wo_code">
            <span class="podium-rank">{{ i + 1 }}</span>
            <div class="podium-info">
              <span class="podium-code">{{ w.wo_code }} <span class="podium-sub">{{ w.project }}</span></span>
              <div class="podium-bar"><div :style="{ width: (w.total / (prStats.topWo[0].total || 1) * 100) + '%' }"></div></div>
            </div>
            <span class="podium-val">{{ w.total }} PR</span>
          </div>
        </div>
      </div>
    </div>

    <div class=" row">
      <div class="col-12">
          <div class="card"> 
            <div class="card-header pb-2">
              <div class="row align-items-center">
                <div class="col-xl-4 col-lg-12 mb-2">
                  <div class="input-group">
                    <span class="input-group-text"><i class="fa fa-search"></i></span>
                    <input type="text" class="form-control" placeholder="Cari no. PR, WO, project, material group, catatan, pembuat..." v-model="search.q" @input="onSearch()">
                  </div>
                </div>
                <div class="col-xl-8 col-lg-12 mb-2 d-flex flex-wrap align-items-center justify-content-xl-end gap-2">
                  <div class="btn-group btn-group-sm mb-0">
                    <button type="button" class="btn mb-0" :class="!search.status && !search.due ? 'btn-primary' : 'btn-outline-primary'" @click="quickStatus('')">Semua</button>
                    <button type="button" class="btn mb-0" :class="search.status == 'Draf' ? 'btn-primary' : 'btn-outline-primary'" @click="quickStatus('Draf')">Draf</button>
                    <button type="button" class="btn mb-0" :class="search.status == 'PR Approved' ? 'btn-primary' : 'btn-outline-primary'" @click="quickStatus('PR Approved')">PR Approved</button>
                    <button type="button" class="btn mb-0" :class="search.due == 'overdue' ? 'btn-danger' : 'btn-outline-danger'" @click="quickDue('overdue')">Lewat Date Required</button>
                  </div>
                  <argon-button variant="gradient" color="secondary" size="sm" @click="filter()"><i class="fa fa-filter fa-sm"></i> Filter</argon-button>
                  <argon-button variant="gradient" color="success" size="sm" @click="createWithSubForm()"><i class="fa fa-plus fa-sm"></i> Add New</argon-button>
                </div>
              </div>
              <div v-if="activeChips.length" class="mt-1">
                <span v-for="chip in activeChips" :key="chip.key" class="badge bg-light text-dark me-2 filter-chip" @click="clearFilter(chip.key)">{{ chip.label }} <i class="fa fa-times ms-1"></i></span>
                <span class="text-xs text-primary filter-chip" @click="resetFilter()">Hapus semua filter</span>
              </div>
              <div class="stage-legend mt-1">
                <span class="text-xxs text-secondary me-1">Warna progres item:</span>
                <span v-for="seg in donutSegments" :key="'lg' + seg.key"><i :style="{ background: seg.color }"></i>{{ seg.label }}</span>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div class="table-responsive p-0 scroll">
                <table class="table table-hover table-striped align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">No</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PR NO</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Project</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">WO NO</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">MATERIAL GROUP</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">DATE REQUIRED</th>
                      <!-- <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">GENERAL NOTE</th> -->
                      <!-- <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ITEM NO</th> -->
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">PROGRES ITEM</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">STATUS</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">CREATED AT</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!onLoading && !table.data.length"><td colspan="10" class="text-center text-sm text-secondary py-5">Tidak ada PR yang cocok dengan filter</td></tr>
                    <tr v-for="(row, i) in table.data" :key="i">
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ (pagination.page - 1) * 100 + i + 1 }}</span>
                      </td>
                      <td class="align-middle text-center text-sm" @click="getDetailTransaction(row.pr_code)" style="cursor: pointer;">
                        <span class="badge badge-sm bg-gradient-primary">  {{ row.pr_code }} <span v-if="row.total_revision"> (Rev. {{ row.total_revision }})</span> </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold"> {{ row.project_type }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.wo_code }} - {{ row.project }} </span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.material_group_code }} - {{ row.group_name }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold d-block">  {{ moment(row.date_required).locale('id').format('LL') }} </span>
                        <span class="req-badge" :class="'req-' + requiredInfo(row).level">{{ requiredInfo(row).label }}</span>
                      </td>
                      <!-- <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.general_note }} </span>
                      </td> -->
                      <!-- <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">  {{ row.item_no }} </span>
                      </td> -->
                      <td class="align-middle text-center text-sm">
                        <div class="stage-wrap" :title="stageTitle(row)">
                          <div class="stage-bar">
                            <div v-for="st in stageSegments(row)" :key="st.key" :class="'sb-' + st.key" :style="{ width: st.pct + '%' }"></div>
                          </div>
                          <span class="text-xxs text-secondary">{{ row.total_item_count }} item · <b class="text-dark">{{ receivedPct(row) }}%</b> diterima</span>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="badge badge-sm" :class="statusClass(row.status)"> {{ row.status }} </span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold d-block">  {{ moment(row.created_at).locale('id').format('LL') }} </span>
                        <span class="text-xxs text-secondary" v-if="row.created_by">{{ row.created_by }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <i class="fa fa-check-circle-o" aria-hidden="true" title="Approve PR ini" style="cursor: pointer; margin-right: 20px;" @click="prApproved(row.pr_code)" v-if="row.status == 'Draf'"></i>
                        <i class="fa fa-trash fa-sm" aria-hidden="true" title="Hapus PR ini" style="cursor: pointer; margin-right: 20px;" @click="remove(row.id, row.total_item_count, row.transaction_type)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <div class="float-right">
                <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

   <!-- ===========================================  MODAL ADD DATA WITH SUB FORM =============================================== -->
  <div class="container">
    <vue-final-modal v-model="formSub.show" classes="modal-container" content-class="modal-content-width" :z-index="10000" :focus-retain="false">
      <!-- header -->
      <div class="row">
        <div class="col-11 text-center">
          <span class="modal__title">{{formSub.title}} <template v-if="headerData.transaction_type">{{ headerData.transaction_type.toUpperCase() }} ====</template></span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formSub.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <div class="row">
          <div class="col-10 text-center">
          </div>
          <div class="col-2 float-right">
            <argon-button
              v-if="formSub.title == '==== TRANSACTION PR DETAIL ===='"
              style="margin-right: 10px;"
              variant="gradient"
              color="info"
              size="sm"
              @click="saveHeader()"
              :disabled="onLoading"
            ><i class="fa fa-save fa-sm"></i> Save Header</argon-button>
            <a class="btn btn-sm btn-warning" style="margin-left: 0px;" :href="apiUrl+'print-pdf/pr-detail?pr_code='+headerData.pr_no+''" target="_BLANK"><i class="fa fa-print fa-sm"></i> Print</a>
          </div>
        </div>
        <table class="table table-sm table-bordered">
          <tbody>
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> PR NO </td>
              <td> <input type="text" class="form-control" placeholder="PR NO" v-model="headerData.pr_code_rev" disabled> </td>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> STATUS <span style="color: red;">*</span></td>
              <td> <input type="text" class="form-control" placeholder="Status" v-model="headerData.status" disabled> </td>
            </tr>
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> PR TYPE <span style="color: red;">*</span></td>
              <td>
                <select class="form-select" aria-label="Default select example" v-model="headerData.project_type">
                  <option value="Project">Project</option>
                  <option value="Non Project">Non Project</option>
                </select>
              </td>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> DATE REQUIRED <span style="color: red;">*</span></td>
              <td width="300">  <input type="date" class="form-control" placeholder="Date Required" v-model="headerData.date_required"> </td>
            </tr>
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> WO NO <span style="color: red;">*</span></td>
              <td colspan="4"> 
                <multiselect v-model="headerData.wo_no" :options="tableWo.data" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Work Order No" label="wo_code" track-by="wo_code" :preselect-first="true" @keyup="getWo" :custom-label="nameWithLangWo" @select="setByWO()">
                  <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
                </multiselect> 
              </td>
            </tr>
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> MTR / SERVC GRP PR <span style="color: red;">*</span></td>
              <td colspan="4"> 
                <multiselect v-model="headerData.material_group_code" :options="tableMaterialGroupPR.data" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Material / Service Group PR" label="material_group_code" track-by="material_group_code" :preselect-first="true" @keyup="getMaterialGroupPR" :custom-label="nameWithLangMGPr">
                  <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
                </multiselect> 
              </td>
            </tr>
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> CLIENT <span style="color: red;">*</span></td>
              <td width="300">  <input type="text" class="form-control" placeholder="Client" v-model="headerData.client" disabled> 
              </td>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> CONTRACT DELIVERY <span style="color: red;">*</span></td>
              <td> <input type="text" class="form-control" placeholder="Contract Delivery" v-model="headerData.contract_delivery" disabled> </td>
            </tr>
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> Attachment </td>
              <td colspan="2"> <input type="file" accept="application/pdf" class="form-control" placeholder="Attachment" @change="filesChange"> </td>
              <td class="align-middle text-center"><a :href="storageUrl+'attachment_pr/'+headerData.attachment" target="_BLANK" style="color: blue; size: 5px;">{{ headerData.attachmentView }} ...</a></td>
            </tr>
            <tr>
              <td style="background-color: #F0F8FF; font-weight: bold; font-size: 11px;" class="align-middle" width="150"> GENERAL NOTE </td>
              <td colspan="3" rowspan="3">
                <textarea rows="4" class="form-control" v-model="headerData.general_note" placeholder="General Note"></textarea>
              </td>
            </tr>
            
          </tbody>
        </table>
          <!-- ===== FOR ITEM LIST ===== -->
          <div>
            <div class="">
              <hr style="border: 2px solid #008000;">
              <div class="row mb-2">
                <div class="col-lg-6">
                  <div class="card-header pb-0">
                    <h6><i class="fas fa-list-ol" style="margin-right: 10px;"></i> Item List</h6>
                  </div>
                </div>
                <div class="col-lg-6">
                  <argon-button
                    class="mt-4"
                    variant="gradient"
                    color="warning"
                    size="sm"
                    @click="prApproved(headerData.pr_no)"
                    :disabled="onLoading"
                    v-if="headerData.status == 'Draf'"
                  >
                    <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
                    <span v-else>
                        <i class="fa fa-check-circle-o" aria-hidden="true"></i> PR Approved
                    </span>
                  </argon-button>
                  <argon-button color="info" size="sm" class="mt-4" style="margin-left: 10px;" variant="gradient" @click="modalImport()"><i class="fa fa-upload fa-sm"></i> Import</argon-button>
                  <argon-button
                    class="mt-4"
                    style="margin-left: 10px;"
                    variant="gradient"
                    color="success"
                    size="sm"
                    @click="createItem()"
                  ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add New</argon-button>
                </div>
              </div>
              <div class="table-responsive p-0 scroll-model">
                <table class="table table-hover table-striped table-bordered align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">No</th>
                      <!-- <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Image</th> -->
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Part Name</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Specification</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Size</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Unit</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Qty</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Weight</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Rev.</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">MPS NO</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">ITEM NO</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">USE FOR</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">TRACKING</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">STATUS</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in dataListItem.data" :key="i">
                      <td class="align-middle text-center text-sm border">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.no_item }}</span>
                        <!-- <input type="text" class="form-control input-sm" placeholder="No" @change="editItem" :value="row.no_item" :id="row.id" > -->
                      </td>
                      <td class="align-middle text-center text-sm border">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.part_name }}</span>
                      </td>
                      <td class="align-middle text-center text-sm border">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.specification }}</span>
                      </td>
                      <td class="align-middle text-center text-sm border">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.size }}</span>
                      </td>
                      <td class="align-middle text-center text-sm border">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.unit }}</span>
                      </td>
                      <td class="align-middle text-center text-sm border">
                        <!-- <span class="text-secondary text-xs font-weight-bold">{{ row.qty }}</span> -->
                        <input type="number" class="form-control input-sm" placeholder="Qty"  @change="editItem" :value="row.qty" :id="row.id" style="width: 150px;">
                      </td>
                      <td class="align-middle text-center text-sm border">
                        <!-- <span class="text-secondary text-xs font-weight-bold">{{ row.weight }}</span> --> 
                        <input type="number" class="form-control input-sm" placeholder="Weight" @change="editItem" :value="row.weight" :id="row.id" style="width: 150px;">
                      </td>
                      <td class="align-middle text-center text-sm border">
                        <span class="text-xs font-weight-bold" style="color: blue; cursor: pointer;" @click="showRevision(row.item_pr_code)">{{ row.revisi_item }}</span>
                      </td>
                      <td class="align-middle text-center text-sm border">
                        <!-- <span class="text-secondary text-xs font-weight-bold">{{ row.mps_no }}</span> -->
                        <input type="text" class="form-control input-sm" placeholder="Mps No" @change="editItem" :value="row.mps_no" :id="row.id" >
                      </td>
                      <td class="align-middle text-center text-sm border">
                        <!-- <span class="text-secondary text-xs font-weight-bold">{{ row.item_no }}</span> -->
                        <input type="text" class="form-control input-sm" placeholder="Item No" @change="editItem" :value="row.item_no" :id="row.id" >
                      </td>
                      <td class="align-middle text-center text-sm border">
                        <!-- <span class="text-secondary text-xs font-weight-bold">{{ row.use_for }}</span> -->
                        <input type="text" class="form-control input-sm" size="50" placeholder="Use For" @change="editItem" :value="row.use_for" :id="row.id" style="width: 400px;">
                      </td>
                      <td class="align-middle text-center text-sm border">
                        <span class="badge badge-sm bg-gradient-secondary" v-if="row.status == 'Draf'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-info" v-else-if="row.status == 'PR Approved'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-danger" v-else-if="row.status == 'On RFQ'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-warning" v-else-if="row.status == 'RFQ Completed'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-text-light bg-dark" v-else-if="row.status == 'On Comparison'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-muted bg-dark" v-else-if="row.status == 'CP Approved'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-primary" v-else-if="row.status == 'On Purchase Order'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-success" v-else-if="row.status == 'Fixed PO'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-danger" v-else-if="row.status == 'Canceled'">{{ row.status }} </span>
                        <span class="badge badge-sm bg-gradient-warning" v-else>{{ row.status }} </span>
                      </td>
                       <td class="align-middle text-center text-sm border">
                        <!-- <span class="badge bg-gradient-secondary">{{ row.status_item }}</span> -->
                        <select class="form-select" aria-label="Default select example" @change="editItem" :value="row.status_item" :id="row.id" style="width: 180px;">
                          <option value="F/R">F/R - FOR REFERENCE</option>
                          <option value="F/W">F/W - FOR WORKING</option>
                          <option value="H">H - HOLD</option>
                          <option value="R">R - RELEASE</option>
                          <option value="C.L">C.L - CANCELLED</option>
                        </select>
                      </td>
                      <td class="align-middle text-center border">
                        <!-- <i class="fas fa-edit fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="editItem(row.id)" title="Edit" v-if="row.status == 'Draf'"></i> -->
                        <i class="fa fa-trash fa-sm" aria-hidden="true" title="Hapus item ini" style="cursor: pointer; margin-right: 20px;" @click="removeItem(row.id)" v-if="row.status == 'Draf'"></i>
                        <i class="fa fa-deaf fa-sm" aria-hidden="true" title="Ajukan revisi item" style="cursor: pointer; margin-right: 20px;" @click="revisiItem(row.id)" v-if="row.status != 'Draf'"></i>
                        <i class="fa fa-window-close fa-sm" aria-hidden="true" title="Cancel item ini" style="cursor: pointer; margin-right: 20px;" @click="prItemCancle(row.id)" v-if="row.status != 'Canceled'"></i>
                        <i class="fa fa-undo fa-sm" aria-hidden="true" title="Aktifkan lagi (kembalikan ke status sebelum di-cancel)" style="cursor: pointer; margin-right: 20px;" @click="prItemUncancle(row.id)" v-if="row.status == 'Canceled'"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <!-- <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="headerData = {}">Clear</argon-button> -->
        </div>
        <div class="col-1">
          <!-- <argon-button variant="gradient" color="success" size="sm" width="1" @click="save()" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span>Save</span>
            </span>
          </argon-button> -->
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

  <!-- =======  MODAL ADD DATA ITEM ======= -->
  <div class="container">
    <vue-final-modal v-model="formAddItem.show" classes="modal-container" content-class="modal-content-width" :z-index="10000" :focus-retain="false">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formAddItem.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formAddItem.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <div class="table-responsive p-0 scroll-model">
          <input type="text" class="form-control mb-4" placeholder="Search Part Name ..." @keyup="createItem()" v-model="searchPartName">
          <table class="table table-hover table-striped table-bordered align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Action</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">No</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Code</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Part Name</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Specification</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Size</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Unit</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableItemList.data" :key="i">
                <td class="align-middle text-center border">
                  <i class="fa fa-plus-circle fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="setAddItem(row.item_code, row.item_name, row.specification, row.size, row.unit)" title="Add Item"></i>
                </td>
                <td class="align-middle text-center text-sm border">
                  <span class="text-secondary text-xs font-weight-bold">{{ i + 1 }}</span>
                </td>
                <td class="align-middle text-center text-sm border">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.item_code }}</span>
                </td>
                <td class="align-middle text-center text-sm border">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.item_name }}</span>
                </td>
                <td class="align-middle text-center text-sm border">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.specification }}</span>
                </td>
                <td class="align-middle text-center text-sm border">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.size }}</span>
                </td>
                <td class="align-middle text-center text-sm border">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.unit }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>


        <!-- KONSEP OLD -->
        <!-- <label for="example-text-input" class="form-control-label mt-3">No <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="No" v-model="itemData.no_item">
        <label for="example-text-input" class="form-control-label mt-3">Part Name <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Part Name" v-model="itemData.part_name">
        <label for="example-text-input" class="form-control-label mt-3">Specification <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Specification" v-model="itemData.specification">
        <label for="example-text-input" class="form-control-label mt-3">Size <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Size" v-model="itemData.size">
        <label for="example-text-input" class="form-control-label mt-3">Unit <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="itemData.unit">
          <option value="Batang">Batang</option>
          <option value="Box">Box</option> 
          <option value="Btl">Btl</option>
          <option value="Can">Can</option>
          <option value="Cyl">Cyl</option>
          <option value="Drum">Drum</option>
          <option value="Ea">Ea</option>
          <option value="Kg">Kg</option>
          <option value="Kaleng">Kaleng</option>
          <option value="Lembar">Lembar</option>
          <option value="Liter">Liter</option>
          <option value="Lusin">Lusin</option>
          <option value="Mtr">Mtr</option>
          <option value="M3">M3</option>
          <option value="Pack">Pack</option>
          <option value="Pasang">Pasang</option>
          <option value="Pcs">Pcs</option>
          <option value="Rim">Rim</option>
          <option value="Roll">Roll</option>
          <option value="Set">Set</option>
          <option value="Tbg">Tbg</option>
          <option value="Unit">Unit</option>        
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Qty <span style="color: red;">*</span></label>
        <input type="number" class="form-control" placeholder="Qty" v-model="itemData.qty">
        <label for="example-text-input" class="form-control-label mt-3">Weight </label>
        <input type="number" class="form-control" placeholder="Weight" v-model="itemData.weight"> -->
        <!-- <label for="example-text-input" class="form-control-label mt-3">Rev. </label> -->
        <!-- <input type="number" class="form-control" placeholder="Rev." v-model="itemData.revisi_item"> -->
        <!-- <label for="example-text-input" class="form-control-label mt-3">MPS No </label>
        <input type="text" class="form-control" placeholder="MPS No" v-model="itemData.mps_no">
        <label for="example-text-input" class="form-control-label mt-3">Item No </label>
        <input type="text" class="form-control" placeholder="Item No" v-model="itemData.item_no">
        <label for="example-text-input" class="form-control-label mt-3">Use For </label>
        <input type="text" class="form-control" placeholder="Use For" v-model="itemData.use_for">
        <label for="example-text-input" class="form-control-label mt-3">Status <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="itemData.status_item">
          <option value="F/R">F/R - FOR REFERENCE</option>
          <option value="F/W">F/W - FOR WORKING</option>
          <option value="H">H - HOLD</option>
          <option value="R">R - RELEASE</option>
          <option value="C.L">C.L - CANCELLED</option>
        </select> -->
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="itemData = {}, tableItem.data = []">Clear</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="save()" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span>Save</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- =======  MODAL REVISION ITEM ======= -->
  <div class="container">
    <vue-final-modal v-model="formRevisiItem.show" classes="modal-container" content-class="modal-content" :z-index="100000" :focus-retain="false">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formRevisiItem.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formRevisiItem.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">No <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="No" v-model="itemData.no_item">
        <label for="example-text-input" class="form-control-label mt-3">Part Name <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Part Name" v-model="itemData.part_name">
        <label for="example-text-input" class="form-control-label mt-3">Specification <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Specification" v-model="itemData.specification">
        <label for="example-text-input" class="form-control-label mt-3">Size <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Size" v-model="itemData.size">
        <label for="example-text-input" class="form-control-label mt-3">Unit <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="itemData.unit">
          <option v-for="(u, k) in tableUom.data" :key="k" :value="u.code">{{ u.name }}</option>
        </select>

        <label for="example-text-input" class="form-control-label mt-3">Qty <span style="color: red;">*</span></label>
        <input type="number" class="form-control" placeholder="Qty" v-model="itemData.qty">
        <label for="example-text-input" class="form-control-label mt-3">Weight </label>
        <input type="number" class="form-control" placeholder="Weight" v-model="itemData.weight">
        <!-- <label for="example-text-input" class="form-control-label mt-3">Rev. </label> -->
        <!-- <input type="number" class="form-control" placeholder="Rev." v-model="itemData.revisi_item"> -->
        <label for="example-text-input" class="form-control-label mt-3">MPS No </label>
        <input type="text" class="form-control" placeholder="MPS No" v-model="itemData.mps_no">
        <label for="example-text-input" class="form-control-label mt-3">Item No </label>
        <input type="text" class="form-control" placeholder="Item No" v-model="itemData.item_no">
        <label for="example-text-input" class="form-control-label mt-3">Use For </label>
        <input type="text" class="form-control" placeholder="Use For" v-model="itemData.use_for">
        <label for="example-text-input" class="form-control-label mt-3">Status <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="itemData.status_item">
          <option value="F/R">F/R - FOR REFERENCE</option>
          <option value="F/W">F/W - FOR WORKING</option>
          <option value="H">H - HOLD</option>
          <option value="R">R - RELEASE</option>
          <option value="C.L">C.L - CANCELLED</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Reason For Revision <span style="color: red;">*</span></label>
        <textarea rows="4" class="form-control" v-model="itemData.reason_revision" placeholder="Reason For Revision"></textarea>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="itemData = {}, tableItem.data = []">Clear</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="saveRevision()" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span>Save</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- =======  MODAL SHOW REVISION ======= -->
  <div class="container">
    <vue-final-modal v-model="formShowRevision.show" classes="modal-container" content-class="modal-content" :z-index="100000" :focus-retain="false">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formShowRevision.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formShowRevision.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
        <div class="table-responsive p-0 scroll-model">
          <table class="table table-hover table-striped table-bordered align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">No</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Revision</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Reason</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Revision At</th>
                <th class="text-center text-uppercase text-white text-xxs font-weight-bolder">Revision By</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableShowRevision.data" :key="i">
                <td class="align-middle text-center text-sm border">
                  <span class="text-secondary text-xs font-weight-bold">{{ i + 1 }}</span>
                </td>
                <td class="align-middle text-left text-sm border">
                  <span class="text-secondary text-xs font-weight-bold" v-html="row.revision"></span>
                </td>
                <td class="align-middle text-center text-sm border">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.reason_revision }}</span>
                </td>
                <td class="align-middle text-center text-sm border">
                  <span class="text-secondary text-xs font-weight-bold">{{ moment(row.created_at).locale('id').format('LLL') }}</span>
                </td>
                <td class="align-middle text-center text-sm border">
                  <span class="text-secondary text-xs font-weight-bold">{{ row.created_by }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      <!-- footer -->
      <div class="row float-right mt-3">
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- ================================================  MODAL FILTER ============================================== -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilter.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">PR NO </label>
        <input type="text" class="form-control" placeholder="PR NO" v-model="search.pr_code">
        <label for="example-text-input" class="form-control-label mt-3">PR Type </label>
        <select class="form-select" aria-label="Default select example" v-model="search.project_type">
          <option value="Project">Project</option>
          <option value="Non Project">Non Project</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">WO NO </label>
        <multiselect v-model="search.wo_code" :options="tableWo.data" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Work Order No" label="wo_code" track-by="wo_code" :preselect-first="true" @keyup="getWo" :custom-label="nameWithLangWo">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect> 
        <label for="example-text-input" class="form-control-label mt-3">MATERIAL GROUP </label>
        <multiselect v-model="search.material_group_code" :options="tableMaterialGroupPR.data" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Material / Service Group PR" label="material_group_code" track-by="material_group_code" :preselect-first="true" @keyup="getMaterialGroupPR" :custom-label="nameWithLangMGPr">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect> 
        <label for="example-text-input" class="form-control-label mt-3">Date Required </label>
        <input type="text" class="form-control" placeholder="Date Required" v-model="search.date_required">
        <label for="example-text-input" class="form-control-label mt-3">General Note </label>
        <input type="text" class="form-control" placeholder="General Note" v-model="search.general_note">
        <label for="example-text-input" class="form-control-label mt-3">Item No </label>
        <input type="text" class="form-control" placeholder="Item No" v-model="search.item_no">
        <label for="example-text-input" class="form-control-label mt-3">Tracking </label>
        <select class="form-select" aria-label="Default select example" v-model="search.status">
          <option value="Draf">Draf</option>
          <option value="PR Approved">PR Approved</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Create Date</label> 
        <flat-pickr :config="{ mode: 'range',}" class="form-control mb-4" v-model="search.date"/>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="resetFilter()">Clear</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="reload()" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span>Filter</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- =======  MODAL IMPORT ======= -->
  <div class="container">
    <vue-final-modal v-model="formImport.show" classes="modal-container" content-class="modal-content" :z-index="10000">
    <!-- header -->
    <div class="row">
      <div class="col-11 float-left">
        <span class="modal__title">{{formImport.title}}</span>
      </div>
      <div class="col-1 float-right">
        <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formImport.show = false"></i>
      </div>
    </div><hr>
    <!-- end header -->
    <div class="modal__content container">
      <div>
        <label for="example-text-input" class="form-control-label mt-3">Upload File <span style="color: red;">*</span></label>
        <input type="file" class="form-control" placeholder="Upload File" @change="filesChangeImport" style="margin-bottom: 20px;">
        <small>Download Template<a :href="storageUrl+'/template_import/Template Import PR Item.xlsx'" style="color: blue;"> Import PR Item</a></small>
        <div class="mt-2" v-if="tabelError.data.length !== 0 ">
          <table>
            <thead>
              <slot name="columns">
                <tr style="background-color: #F0F8FF;">
                  <th style="font-size: 13px; text-align: center; border: 1pt solid #DCDCDC; width: 50px;">No</th>
                  <th style="font-size: 13px; text-align: center; border: 1pt solid #DCDCDC; width: 50px;">Column</th>
                  <th style="font-size: 13px; text-align: center; border: 1pt solid #DCDCDC; width: 150px;">Error</th>
                  <th style="font-size: 13px; text-align: center; border: 1pt solid #DCDCDC; width: 50px;">Row</th>
                  <th style="font-size: 13px; text-align: center; border: 1pt solid #DCDCDC; width: 150px;">Values</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tabelError.data" :key="i">
                <td style="font-size: 13px; text-align: center; border: 1pt solid #DCDCDC;">{{ i + 1 }}</td>
                <td style="font-size: 13px; text-align: center; border: 1pt solid #DCDCDC;">{{ row.attribute }}</td>
                <td style="font-size: 13px; text-align: center; border: 1pt solid #DCDCDC;">{{ row.errors }}</td>
                <td style="font-size: 13px; text-align: center; border: 1pt solid #DCDCDC;">{{ row.row }}</td>
                <td style="font-size: 13px; text-align: center; border: 1pt solid #DCDCDC;">{{ row.values }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- footer -->
    <div class="row float-right mt-5">
      <div class="col-6"> 
      </div>
      <div class="col-2" style="margin-right: 20px;">
        <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formImport.show = false">Close</argon-button>
      </div>
      <div class="col-1">
        <button type="primary" class="btn btn-sm btn-info btn-fill" @click="importData()" :disabled="onLoading">
          <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
          <span v-else>
              <span>Import</span>
          </span>
        </button>
        <!-- <argon-button variant="gradient" color="success" size="sm" width="1" @click="get(), formImport.show = false">Import</argon-button> -->
      </div>
    </div>
    <!-- end footer -->
    </vue-final-modal>
  </div>

</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import config from '@/configs/config';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css';
var moment = require('moment');

const EMPTY_SEARCH = { q: '', due: '', pr_code: '', project_type: '', wo_code: '', material_group_code: '', date_required: '', general_note: '', item_no: '', status: '', date: '' };
const DONUT_CIRCUMFERENCE = 2 * Math.PI * 48;
// warna & label tahapan item PR (urut sesuai alur), sama dengan PurchasingRequisitionController::ITEM_STAGES
const ITEM_STAGES = [
  { key: 'draft', label: 'Draf', color: '#adb5bd' },
  { key: 'approved', label: 'PR Approved', color: '#fbb140' },
  { key: 'rfq', label: 'RFQ / Comparison', color: '#11cdef' },
  { key: 'po', label: 'Purchase Order', color: '#5e72e4' },
  { key: 'received', label: 'Diterima', color: '#2dce89' },
  { key: 'canceled', label: 'Dibatalkan', color: '#f5365c' },
];
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import purchasingRequisition from '@/services/procurement/purchasingRequisition.service';
import workOrder from '@/services/procurement/workOrder.service';
import materialGroupPR from '@/services/procurement/materialGroupPR.service';
import unitOfMeasurement from '@/services/unitOfMeasurement.service';

export default {
  name: "tables",
  components: {
    ArgonButton,
    VueFinalModal,
    Multiselect,
    BasePagination,
    flatPickr,
  },
  data() {
    return {
      pagination: {
        page_count: '',
        page: 1,
      },
      moment:moment,
      table: {
        data: []
      },
      tableItemList: {
        data: []
      },
      tableShowRevision: {
        data: []
      },
      formSub: {
        add: true,
        title: "==== TRANSACTION PR DETAIL ====",
        show: false
      },
      formAddItem: {
        add: true,
        title: "==== TRANSACTION PR DETAIL ====",
        show: false
      },
      formRevisiItem: {
        add: true,
        title: "==== PR ITEM REVISON ====",
        show: false
      },
      formShowRevision: {
        add: true,
        title: "==== SHOW REVISON ====",
        show: false
      },
      formImport: {
        add: true,
        title: "Import PR Item",
        show: false
      },
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      dataImport: '',
      onLoading: false,
      tabelError: {
        data: []
      },
      storageUrl : config.storageUrl,
      headerData: {},
      search: { ...EMPTY_SEARCH },
      searchTimer: null,
      requestSeq: 0,
      prStats: { summary: {}, stages: {}, topWo: [] },
      apiUrl :config.apiUrl,
      tableWo: {
        data: []
      },
      tableMaterialGroupPR: {
        data: []
      },
      tableUom: {
        data: []
      },
      tableItem: {
        data: []
      },

      // ----- Item Transaction -----
      dataTransaction: {},
      dataListItem: {
        data: []
      },
      itemData: {},
      searchPartName: '',
    };
  },
  computed: {
    // donut komposisi item PR per tahapan
    donutSegments() {
      const stages = this.prStats.stages || {};
      const total = stages.total || 0;
      let offset = 0;
      return ITEM_STAGES.map(st => {
        const value = stages[st.key] || 0;
        const len = total ? value / total * DONUT_CIRCUMFERENCE : 0;
        const seg = { ...st, value, dash: len + ' ' + DONUT_CIRCUMFERENCE, offset: -offset };
        offset += len;
        return seg;
      });
    },
    activeChips() {
      const chips = [];
      const add = (key, label) => chips.push({ key, label });
      if (this.search.pr_code) add('pr_code', 'PR: ' + this.search.pr_code);
      if (this.search.project_type) add('project_type', 'Tipe: ' + this.search.project_type);
      if (this.search.wo_code && this.search.wo_code.wo_code) add('wo_code', 'WO: ' + this.search.wo_code.wo_code);
      if (this.search.material_group_code && this.search.material_group_code.material_group_code) add('material_group_code', 'Group: ' + this.search.material_group_code.material_group_code);
      if (this.search.date_required) add('date_required', 'Date Required: ' + this.search.date_required);
      if (this.search.general_note) add('general_note', 'Note: ' + this.search.general_note);
      if (this.search.item_no) add('item_no', 'Item No: ' + this.search.item_no);
      if (this.search.date) add('date', 'Dibuat: ' + this.search.date);
      return chips;
    },
  },
  mounted(){
    this.get();
    this.getStats();
    this.getUom();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
  },
  methods: {
    getUom(){
      let context = this;
      Api(context, unitOfMeasurement.index()).onSuccess(function(response) {
          context.tableUom.data = response.data.data.data;
      }).onError(function(error) {
          if (error.response.status == 404) {
              context.tableUom.data = [];
          }
      })
      .call()
    },
    nameWithLangWo ({ wo_code, project }) {
      return `${wo_code} - ${project}`
    },
    nameWithLangMGPr ({ material_group_code, group_name }) {
      return `${material_group_code} - ${group_name}`
    },
    get(param){
      let context = this; 
      context.onLoading = true;

      const seq = ++context.requestSeq;
      Api(context, purchasingRequisition.getAllPr({q: this.search.q, due: this.search.due, pr_code: this.search.pr_code, project_type: this.search.project_type, wo_code: (this.search.wo_code || {})['wo_code'], material_group_code: (this.search.material_group_code || {})['material_group_code'], date_required: this.search.date_required, general_note: this.search.general_note, item_no: this.search.item_no, status: this.search.status, date: this.search.date, page: context.pagination.page})).onSuccess(function(response) {
          if (seq != context.requestSeq) return;
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page

          // context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {
          if (seq != context.requestSeq) return;
          context.table.data = [];
          context.pagination.page_count = 1;
          // 404 = tidak ada PR yang cocok dengan filter, bukan error
          if (!error.response || error.response.status != 404) {
              context.notify('Data Retrieved Failed', 'error')
          }
      }).onFinish(function() {
         context.formFilter.show = false;
         if (seq == context.requestSeq) context.onLoading = false;
      })
      .call()
    },
    getWo(param){
      if (param.target.value.length >= 3) {
        let context = this;        
        Api(context, workOrder.getWo({search: param.target.value})).onSuccess(function(response) {    
            context.tableWo.data = response.data.data;
        }).onError(function(error) {                    
            if (error.response.status == 404) {
                context.tableWo.data = [];
            }
        }).onFinish(function() { 
        })
        .call()
      }
    },
    getMaterialGroupPR(param){
      if (param.target.value.length >= 1) {
        let context = this;        
        Api(context, materialGroupPR.getMaterialGroupPR({search: param.target.value})).onSuccess(function(response) {    
            context.tableMaterialGroupPR.data = response.data.data;
        }).onError(function(error) {                    
            if (error.response.status == 404) {
                context.tableMaterialGroupPR.data = [];
            }
        }).onFinish(function() { 
        })
        .call()
      }
    },
    getDetailTransaction(trxnumber){
      let context = this;               
      Api(context, purchasingRequisition.transactionDetail({pr_code: trxnumber})).onSuccess(function(response) {    
          context.headerData.id                  = response.data.data.data.id;
          if (response.data.data.data.total_revision) {
            context.headerData.pr_code_rev = response.data.data.data.pr_code + '(Rev.'+response.data.data.data.total_revision+')';

          }else{
            context.headerData.pr_code_rev = response.data.data.data.pr_code;
          }
          context.headerData.pr_no               = response.data.data.data.pr_code;
          context.headerData.project_type        = response.data.data.data.project_type;
          context.headerData.wo_no               = response.data.data.data.wo_code;
          context.headerData.material_group_code = response.data.data.data.material_group_code;
          context.headerData.date_required       = response.data.data.data.date_required;
          context.headerData.status              = response.data.data.data.status;
          context.headerData.general_note        = response.data.data.data.general_note;
          context.headerData.item_no             = response.data.data.data.item_no;
          context.headerData.client              = response.data.data.data.client;
          context.headerData.contract_delivery   = response.data.data.data.contract_delivery;
          context.headerData.attachment          = response.data.data.data.attachment;
          context.headerData.attachmentView      = response.data.data.data.attachment.substring(0,30);

          context.headerData.wo_no               = response.data.data.dataWo;
          context.headerData.material_group_code = response.data.data.dataMGPR;

          context.dataListItem.data = response.data.data.dataListItem;

          context.formSub.add   = true;
          context.formSub.show  = true;
          context.formSub.title = "==== TRANSACTION PR DETAIL ====";

          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.headerData = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
      })
      .call()
    },
    setByWO(){
      this.headerData.client            = this.headerData.wo_no['client'];
      this.headerData.contract_delivery = this.headerData.wo_no['due_date'];
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading        = false;
      this.pagination.page  = 1 ;
    },
    createWithSubForm() {
      this.formSub.add       = true;
      this.formSub.show      = true;
      this.formSub.title     = "==== TRANSACTION PR ADD DATA ====";
      this.headerData        = {};
      this.headerData.status = 'Draf',
      this.dataListItem.data = {}
      this.defaultDate()
    },
    createItem() {
      this.formAddItem.add   = true;
      this.formAddItem.show  = true;
      this.formAddItem.title = "Add Item";
      // this.itemData          = {};
      let context = this;           
      Api(context, purchasingRequisition.getItemGroup({item_group: context.headerData.material_group_code.material_group_code, part_name: context.searchPartName})).onSuccess(function(response) {
          context.tableItemList.data = response.data.data.data;  
      })
      .call()
    },
    editItem(param) {
      let id          = param.target.id
      let placeholder = param.target.placeholder


      let context = this;               
      Api(context, purchasingRequisition.showItem(id)).onSuccess(function(response) {
          context.itemData              = response.data.data;
          context.itemData.item_pr_code = response.data.data.item_pr_code;
          // context.formAddItem.show      = true;
          // context.formAddItem.title     = 'Edit Data';  

          if (placeholder == 'No') {
            context.itemData.no_item = param.target.value;
          }
          if (placeholder == 'Qty') {
            context.itemData.qty = param.target.value;
          }
          if (placeholder == 'Weight') {
            context.itemData.weight = param.target.value;
          }
          if (placeholder == 'Mps No') {
            context.itemData.mps_no = param.target.value;
          }
          if (placeholder == 'Item No') {
            context.itemData.item_no = param.target.value;
          }
          if (placeholder == 'Use For') {
            context.itemData.use_for = param.target.value;
          }else{
            context.itemData.status_item = param.target.value;
          }
          context.save() 
      })  
      .call()      
    },
    revisiItem(id) {
      let context = this;               
      Api(context, purchasingRequisition.showItem(id)).onSuccess(function(response) {
          context.itemData              = response.data.data;
          context.itemData.item_pr_code = response.data.data.item_pr_code;
          context.formRevisiItem.show   = true;
          context.formRevisiItem.title  = 'PR ITEM REVISON';   
      })
      .call()        
    },
    filesChange(e) {
      console.log(e.target.files[0])
      this.headerData.attachment = e.target.files[0];
    },
    setAddItem(item_code, item_name, specification, size, unit){
      let context  = this;
      this.itemData = {};

      if (context.headerData.project_type == 'Non Project') {
        context.itemData.no_item = item_code
      }else{
        context.itemData.no_item = item_code
      }
      context.itemData.part_name     = item_name
      context.itemData.specification = specification
      context.itemData.size          = size
      context.itemData.unit          = unit
      context.itemData.status_item   = 'F/W'
      context.save();
    },
    save(id){
      let api      = null;
      let context  = this;
      let formData = new FormData();

      console.log(context.headerData.project_type, context.headerData.wo_no, context.headerData.material_group_code, context.headerData.client, context.headerData.date_required, context.headerData.contract_delivery, context.headerData.status)

      // INSERT HEADER
      if (context.headerData.project_type != undefined && context.headerData.wo_no != undefined && context.headerData.material_group_code != undefined && context.headerData.client != undefined && context.headerData.date_required != undefined && context.headerData.contract_delivery != undefined && context.headerData.status != undefined ) {
        formData.append('pr_no', (context.headerData.pr_no == undefined) ? '' : context.headerData.pr_no);
        formData.append('project_type', context.headerData.project_type);
        formData.append('wo_no', JSON.stringify(context.headerData.wo_no));
        formData.append('material_group_code', JSON.stringify(context.headerData.material_group_code));
        formData.append('date_required', context.headerData.date_required);
        formData.append('status', context.headerData.status);
        formData.append('general_note', (context.headerData.general_note == undefined) ? '-' : context.headerData.general_note);
        formData.append('client', context.headerData.client);
        formData.append('contract_delivery', context.headerData.contract_delivery);
        formData.append('item_no', (context.headerData.item_no == undefined) ? '-' : context.headerData.item_no);
        formData.append('attachment', (context.headerData.attachment == undefined) ? '' : context.headerData.attachment);
      }else{
        return alert('The Red Star Field Header is Mandatory')
      }

      console.log(context.itemData.no_item, context.itemData.part_name, context.itemData.specification, context.itemData.size, context.itemData.unit, context.itemData.qty, context.itemData.status_item)
      // INSERT ITEM
      if (context.itemData.part_name != undefined && context.itemData.specification != undefined && context.itemData.size != undefined && context.itemData.unit != undefined) {
        formData.append('no_item', context.itemData.no_item);
        formData.append('item_pr_code', (context.itemData.item_pr_code == undefined) ? '' : context.itemData.item_pr_code);
        formData.append('part_name', context.itemData.part_name);
        formData.append('specification', context.itemData.specification);
        formData.append('size', context.itemData.size);
        formData.append('unit', context.itemData.unit);
        formData.append('qty', context.itemData.qty);
        formData.append('weight', (context.itemData.weight == undefined) ? '' : context.itemData.weight);
        formData.append('revisi_item', (context.itemData.revisi_item == undefined) ? '' : context.itemData.revisi_item);
        formData.append('mps_no', (context.itemData.mps_no == undefined) ? '-' : context.itemData.mps_no);
        formData.append('item_no', (context.itemData.item_no == undefined) ? '-' : context.itemData.item_no);
        formData.append('use_for', (context.itemData.use_for == undefined) ? '-' : context.itemData.use_for);
        formData.append('status', (context.itemData.status == undefined) ? 'Draf' : context.itemData.status);
        formData.append('status_item', context.itemData.status_item);
        // formData.append('attachment', context.itemData.attachment);
      }else{
        return alert('The Red Star Field Item is Mandatory')
      }

      if (context.formSub.title == '==== TRANSACTION PR ADD DATA ') {
          api = Api(context, purchasingRequisition.create(formData));
      } else {     
          api = Api(context, purchasingRequisition.create(formData));
      }
      api.onSuccess(function(response) {
        context.get();
        context.getDetailTransaction(response.data.data.pr_code);
        context.notify((context.formSub.title === '==== TRANSACTION PR ADD DATA ') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      }).onError(function(error) { 
        context.notify((context.formSub.title != '==== TRANSACTION PR ADD DATA ') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
        context.formAddItem.show = false;
      })
      .call();
    },
    saveHeader(){
      let context  = this;
      let formData = new FormData();

      if (context.headerData.project_type != undefined && context.headerData.wo_no != undefined && context.headerData.material_group_code != undefined && context.headerData.date_required != undefined) {
        formData.append('pr_no', context.headerData.pr_no);
        formData.append('project_type', context.headerData.project_type);
        formData.append('wo_no', JSON.stringify(context.headerData.wo_no));
        formData.append('material_group_code', JSON.stringify(context.headerData.material_group_code));
        formData.append('date_required', context.headerData.date_required);
        formData.append('general_note', (context.headerData.general_note == undefined) ? '-' : context.headerData.general_note);
        formData.append('attachment', (context.headerData.attachment == undefined || typeof context.headerData.attachment == 'string') ? '' : context.headerData.attachment);
      }else{
        return alert('The Red Star Field Header is Mandatory')
      }

      Api(context, purchasingRequisition.updateHeader(formData)).onSuccess(function(response) {
        context.get();
        context.getDetailTransaction(context.headerData.pr_no);
        context.notify('Header Berhasil di Update', 'success')
      }).onError(function(error) {
        context.notify('Header Gagal di Update', 'error')
      })
      .call();
    },
    saveRevision(){
      let api      = null;
      let context  = this;
      let formData = new FormData();

      // INSERT ITEM
      if (context.itemData.no_item != undefined && context.itemData.part_name != undefined && context.itemData.specification != undefined && context.itemData.size != undefined && context.itemData.unit != undefined && context.itemData.qty != undefined && context.itemData.status_item != undefined && context.itemData.reason_revision != undefined) {
        formData.append('no_item', context.itemData.no_item);
        formData.append('item_pr_code', (context.itemData.item_pr_code == undefined) ? '' : context.itemData.item_pr_code);
        formData.append('part_name', context.itemData.part_name);
        formData.append('specification', context.itemData.specification);
        formData.append('size', context.itemData.size);
        formData.append('unit', context.itemData.unit);
        formData.append('qty', context.itemData.qty);
        formData.append('weight', (context.itemData.weight == undefined) ? '' : context.itemData.weight);
        formData.append('revisi_item', (context.itemData.revisi_item == undefined) ? '' : context.itemData.revisi_item);
        formData.append('mps_no', (context.itemData.mps_no == undefined) ? '-' : context.itemData.mps_no);
        formData.append('item_no', (context.itemData.item_no == undefined) ? '-' : context.itemData.item_no);
        formData.append('use_for', (context.itemData.use_for == undefined) ? '-' : context.itemData.use_for);
        formData.append('status_item', context.itemData.status_item);
        formData.append('reason_revision', context.itemData.reason_revision);
        formData.append('pr_code', context.headerData.pr_no);
        // formData.append('attachment', context.itemData.attachment);
      }else{
        return alert('The Red Star Field Item is Mandatory')
      }

      api = Api(context, purchasingRequisition.saveRevision(formData));
      api.onSuccess(function(response) {
        context.get();
        context.getDetailTransaction(context.headerData.pr_no);
        context.itemData = {};
        context.notify((context.formSub.title === '==== TRANSACTION PR ADD DATA ') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      }).onError(function(error) { 
        context.notify((context.formSub.title != '==== TRANSACTION PR ADD DATA ') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
        context.formRevisiItem.show = false;
      })
      .call();
    },
    showRevision(item_pr_code){
      let context = this;               
      Api(context, purchasingRequisition.showRevision(item_pr_code)).onSuccess(function(response) {
          context.tableShowRevision.data = response.data.data;
          context.formShowRevision.show  = true;
          context.formShowRevision.title = 'Revision Data';   
      })
      .call() 
    },
    remove(id, total_item, transaction_type) {
      var r = confirm("Are you sure you want to delete this data ?");
      if (r == true) {
        // if ((transaction_type == 'Reduction') || (total_item == 0)) {
          let context = this;
          Api(context, purchasingRequisition.delete(id)).onSuccess(function(response) {
              context.get();
              context.getStats();
              context.notify('Data Successfully Deleted', 'success')
          }).call();
        // }else{
        //   this.notify('Failed to delete. Please clear items first', 'error')
        // }
      }
    },
    removeItem(id) {
      var r = confirm("Are you sure you want to delete this data ?");
      if (r == true) {
        let context  = this;

        Api(context, purchasingRequisition.deleteItem(id)).onSuccess(function(response) {
            context.get();
            context.getDetailTransaction(context.headerData.pr_no);
            context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    prApproved(param){
      let api      = null;
      let context  = this;
      context.onLoading = true;

      api = Api(context, purchasingRequisition.prApproved({pr_code: param}));
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.getDetailTransaction(context.headerData.pr_no)
        context.get();
        context.getStats();
        context.notify((context.form === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) { 
        context.notify((context.form != 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
        context.onLoading = false;
      })
      .call();
    },
    modalImport(){
      this.formImport.show  = true;
      this.formImport.title = "Import PR Item";
      this.tabelError.data  = [];
    },
    filesChangeImport(e) {
        this.dataImport = e.target.files[0];
    },
    importData(){
      let api = null;
      let context = this;
      let formData = new FormData();
      this.onLoading = true;

      // INSERT HEADER
      if (context.headerData.project_type != undefined && context.headerData.wo_no != undefined && context.headerData.material_group_code != undefined && context.headerData.client != undefined && context.headerData.date_required != undefined && context.headerData.contract_delivery != undefined && context.headerData.status != undefined ) {
        formData.append('pr_no', (context.headerData.pr_no == undefined) ? '' : context.headerData.pr_no);
        formData.append('project_type', context.headerData.project_type);
        formData.append('wo_no', JSON.stringify(context.headerData.wo_no));
        formData.append('material_group_code', JSON.stringify(context.headerData.material_group_code));
        formData.append('date_required', context.headerData.date_required);
        formData.append('status', context.headerData.status);
        formData.append('general_note', (context.headerData.general_note == undefined) ? '-' : context.headerData.general_note);
        formData.append('client', context.headerData.client);
        formData.append('contract_delivery', context.headerData.contract_delivery);
        formData.append('item_no', (context.headerData.item_no == undefined) ? '-' : context.headerData.item_no);
      }else{
        context.onLoading = false;
        return alert('The Red Star Field Header is Mandatory')
      }

      if (this.dataImport != undefined) {
        formData.append('import_data', this.dataImport);
      }else{
        context.onLoading = false;
        return alert('File Import Not Found')
      }

      api = Api(context, purchasingRequisition.import(formData));
      api.onSuccess(function(response) {
          context.onLoading = false;
          context.get();
          context.getDetailTransaction(response.data.data);
          context.formImport.show = false;
          context.notify('Import Data Success', 'success')
      }).onError(function(error) {      
          context.tabelError.data = error.response.data.data;              
          context.notify('Import Data Failed', 'error')
          context.onLoading = false;
      }).onFinish(function() {  
      })
      .call();
    },
    prItemCancle(id){
      let api      = null;
      let context  = this;

      api = Api(context, purchasingRequisition.prItemCancle(id));
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.getDetailTransaction(context.headerData.pr_no);
        context.notify('Item Berhasil di Cancel', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) {
        context.notify('Item Gagal di Cancel', 'error')
      }).onFinish(function() {
      })
      .call();
    },
    prItemUncancle(id){
      let api      = null;
      let context  = this;

      api = Api(context, purchasingRequisition.prItemUncancle(id));
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.getDetailTransaction(context.headerData.pr_no);
        context.notify('Item Berhasil di Aktifkan Kembali', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) {
        context.notify('Item Gagal di Aktifkan Kembali', 'error')
      }).onFinish(function() {
      })
      .call();
    },
    defaultDate(){
      var date  = new Date();
      var day   = ("0" + date.getDate()).slice(-2);
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var today = date.getFullYear() + "-" + (month) + "-" + (day);

      this.headerData.date = today
    },
    changePage(page){
      this.pagination.page = page;
      this.get();
    },
    getStats() {
      let context = this;
      Api(context, purchasingRequisition.stats()).onSuccess(function(response) {
        context.prStats = response.data.data;
      }).call();
    },
    reload() {
      this.pagination.page = 1;
      this.get();
    },
    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.reload(), 400);
    },
    quickSearch(text) {
      this.search.q = text;
      this.reload();
    },
    quickStatus(status) {
      this.search.status = status;
      this.search.due = '';
      this.reload();
    },
    quickDue(due) {
      this.search.due = due;
      this.search.status = '';
      this.reload();
    },
    clearFilter(key) {
      this.search[key] = '';
      this.reload();
    },
    resetFilter() {
      this.search = { ...EMPTY_SEARCH };
      this.formFilter.show = false;
      this.reload();
    },
    // ===== helper tampilan progres item =====
    stageSegments(row) {
      const pr = row.progress || {};
      const total = pr.total || 0;
      return ITEM_STAGES.filter(st => pr[st.key]).map(st => ({ key: st.key, pct: total ? pr[st.key] / total * 100 : 0 }));
    },
    stageTitle(row) {
      const pr = row.progress || {};
      return ITEM_STAGES.filter(st => pr[st.key]).map(st => st.label + ': ' + pr[st.key]).join('\n') || 'Belum ada item';
    },
    // % item diterima, tidak menghitung item yang dibatalkan
    receivedPct(row) {
      const pr = row.progress || {};
      const active = (pr.total || 0) - (pr.canceled || 0);
      return active > 0 ? Math.round((pr.received || 0) / active * 100) : 0;
    },
    requiredInfo(row) {
      const pr = row.progress || {};
      if (pr.total && !pr.open) return { level: 'done', label: pr.received ? 'Selesai' : 'Dibatalkan' };
      if (!row.date_required) return { level: 'none', label: '-' };
      const diff = moment(row.date_required).startOf('day').diff(moment().startOf('day'), 'days');
      if (diff < 0) return { level: 'over', label: 'Lewat ' + Math.abs(diff) + ' hari' };
      if (diff == 0) return { level: 'soon', label: 'Hari ini' };
      if (diff <= 7) return { level: 'soon', label: diff + ' hari lagi' };
      return { level: 'ok', label: diff + ' hari lagi' };
    },
    statusClass(status) {
      const map = { 'Draf': 'bg-gradient-secondary', 'PR Approved': 'bg-gradient-success', 'On Purchase Order': 'bg-gradient-primary', 'RFQ Completed': 'bg-gradient-info', 'CP Approved': 'bg-gradient-info' };
      return map[status] || 'bg-gradient-info';
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }
    },

  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
/*MODAL WIDTH KUSUS LEBAR BESAR*/
::v-deep .modal-content-width {
  /*display: flex;*/
  /*flex-direction: column;*/
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 1090px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll-model { 
  overflow: auto;  
}
.scroll-model thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}
.scroll {
  overflow: auto;
  max-height: 600px;
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}
/* ===== hero ===== */
.hero {
  position: relative; overflow: hidden; border-radius: 20px; padding: 22px 26px 18px; color: #fff;
  background: radial-gradient(circle at 85% 10%, rgba(94, 114, 228, .55), transparent 45%),
              radial-gradient(circle at 10% 110%, rgba(17, 205, 239, .35), transparent 40%),
              linear-gradient(135deg, #141727 0%, #252a4a 60%, #1b2f4f 100%);
  box-shadow: 0 18px 40px rgba(20, 23, 39, .35);
}
.hero::after {
  content: ''; position: absolute; inset: 0; pointer-events: none; opacity: .07;
  background-image: repeating-linear-gradient(45deg, #fff 0 2px, transparent 2px 14px);
}
.hero-head { display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 12px; position: relative; z-index: 1; }
.hero-kicker { font-size: .7rem; letter-spacing: .14em; text-transform: uppercase; color: #ffd600; font-weight: 700; }
.hero-title { color: #fff; font-weight: 800; margin: 2px 0 0; letter-spacing: -.02em; }
.hero-sub { font-size: .8rem; opacity: .7; }
.hero-actions { display: flex; gap: 8px; }
.hero-btn {
  display: inline-flex; align-items: center; gap: 6px; height: 38px; min-width: 38px; justify-content: center; padding: 0 12px;
  border-radius: 10px; border: 1px solid rgba(255,255,255,.18); background: rgba(255,255,255,.08); color: #fff; font-size: .8rem; font-weight: 600;
  transition: background .15s;
}
.hero-btn:hover { background: rgba(255,255,255,.18); color: #fff; }
.hero-btn-main { background: #ffd600; color: #1b1b1b; border-color: #ffd600; padding: 0 16px; }
.hero-btn-main:hover { background: #ffe24d; color: #1b1b1b; }
.hero-body { display: grid; grid-template-columns: 150px 170px 1fr 1fr; gap: 26px; align-items: center; margin-top: 18px; position: relative; z-index: 1; }
@media (max-width: 1200px) { .hero-body { grid-template-columns: 150px 1fr; } }
.donut-wrap { position: relative; width: 150px; height: 150px; }
.donut { width: 100%; height: 100%; transform: rotate(-90deg); }
.donut-track { fill: none; stroke: rgba(255,255,255,.1); stroke-width: 14; }
.donut-seg { fill: none; stroke-width: 14; transition: stroke-dasharray .6s ease; }
.donut-center { position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; }
.donut-num { font-size: 2.2rem; font-weight: 800; line-height: 1; }
.donut-lbl { font-size: .65rem; opacity: .7; text-transform: uppercase; letter-spacing: .08em; }
.donut-legend { display: flex; flex-direction: column; gap: 4px; }
.legend-row { display: flex; align-items: center; gap: 8px; padding: 5px 8px; border-radius: 8px; cursor: pointer; font-size: .78rem; }
.legend-row:hover, .legend-row.active { background: rgba(255,255,255,.1); }
.legend-dot { width: 10px; height: 10px; border-radius: 3px; }
.legend-name { flex: 1; opacity: .85; }
.legend-val { font-weight: 800; }
.legend-hint { font-size: .62rem; opacity: .45; padding-left: 8px; }
.hero-metrics { display: grid; grid-template-columns: 1fr; gap: 12px; }
.metric { border-left: 3px solid rgba(255,255,255,.18); padding-left: 12px; }
.metric-lbl { display: block; font-size: .68rem; text-transform: uppercase; letter-spacing: .06em; opacity: .65; }
.metric-lbl i { margin-right: 4px; }
.metric-val { display: block; font-size: 1.35rem; font-weight: 800; line-height: 1.25; }
.metric-val small { font-size: .8rem; opacity: .55; font-weight: 600; }
.metric-note { display: block; font-size: .68rem; opacity: .6; }
.metric-bar { height: 5px; border-radius: 3px; background: rgba(255,255,255,.12); margin: 4px 0 3px; max-width: 260px; overflow: hidden; }
.metric-bar div { height: 100%; background: linear-gradient(90deg, #2dce89, #2dcecc); border-radius: 3px; }
.text-danger-soft { color: #ff8fa3; }
.podium { background: rgba(255,255,255,.06); border: 1px solid rgba(255,255,255,.1); border-radius: 14px; padding: 12px 14px; }
.podium-title { display: block; font-size: .68rem; text-transform: uppercase; letter-spacing: .06em; opacity: .65; margin-bottom: 6px; }
.podium-row { display: flex; align-items: center; gap: 10px; padding: 5px 4px; border-radius: 8px; cursor: pointer; }
.podium-row:hover { background: rgba(255,255,255,.08); }
.podium-rank { width: 20px; height: 20px; border-radius: 6px; background: rgba(255,255,255,.12); font-size: .7rem; font-weight: 800; display: flex; align-items: center; justify-content: center; }
.podium-row:first-of-type .podium-rank { background: #ffd600; color: #1b1b1b; }
.podium-info { flex: 1; min-width: 0; }
.podium-code { font-size: .75rem; font-weight: 700; }
.podium-bar { height: 4px; border-radius: 2px; background: rgba(255,255,255,.1); margin-top: 3px; overflow: hidden; }
.podium-bar div { height: 100%; background: linear-gradient(90deg, #ffd600, #fb6340); }
.podium-val { font-size: .75rem; font-weight: 700; white-space: nowrap; }
.hero-warn { position: relative; z-index: 1; font-size: .68rem; color: #ffcf8a; margin: 12px 0 0; }

.hero-body { grid-template-columns: 150px 190px 1fr 1.1fr; }
@media (max-width: 1200px) { .hero-body { grid-template-columns: 150px 1fr; } }
.legend-row.no-click { cursor: default; padding: 3px 8px; }
.legend-row.no-click:hover { background: none; }
.metric-click { cursor: pointer; border-radius: 0 8px 8px 0; transition: background .15s; }
.metric-click:hover { background: rgba(255,255,255,.07); }
.text-warn-soft { color: #ffd08a; }
.podium-sub { font-weight: 400; opacity: .6; margin-left: 4px; font-size: .68rem; }
.podium-code { display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
/* ===== tabel PR ===== */
.filter-chip { cursor: pointer; }
.stage-wrap { min-width: 150px; }
.stage-legend { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; font-size: .68rem; color: #67748e; }
.stage-legend i { display: inline-block; width: 10px; height: 6px; border-radius: 3px; margin-right: 4px; vertical-align: middle; }
.stage-bar { display: flex; height: 8px; border-radius: 4px; overflow: hidden; background: #eef1f6; margin-bottom: 3px; }
.stage-bar div { height: 100%; }
.sb-draft { background: #adb5bd; }
.sb-approved { background: #fbb140; }
.sb-rfq { background: #11cdef; }
.sb-po { background: #5e72e4; }
.sb-received { background: #2dce89; }
.sb-canceled { background: #f5365c; }
.req-badge { display: inline-block; font-size: .62rem; font-weight: 700; border-radius: 6px; padding: 1px 7px; margin-top: 2px; }
.req-over { background: #fde1e6; color: #d6214a; }
.req-soon { background: #ffe8dc; color: #c2541f; }
.req-ok { background: #e1f7fb; color: #0a8aa3; }
.req-done { background: #d8f7e9; color: #1a8f5c; }
.req-none { background: #e9ecef; color: #67748e; }
</style>
